import { eventBus } from '../main';

function addError(msg, type = 'error') {
    eventBus.$emit('addError', msg, type);
}

// Errors will be given as a param in the callback
function getErrors(callback) {
    eventBus.$emit('getErrors', callback);
}

function clearErrors() {
    eventBus.$emit('clearErrors');
}

/* Export */
export default {
    addError: addError,
    getErrors: getErrors,
    clearErrors: clearErrors,
    TYPE_ERROR: 'error',
    TYPE_INFO: 'info',
    TYPE_SUCCESS: 'success'
};
